import Button, { ButtonLevel } from 'components/Button';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';

type DefaultProps = {
  locale: string;
};

type Props = {
  type: 'link' | 'button';
  group: Group;
  level: ButtonLevel;
  children: React.ReactNode;
} & DefaultProps;

class PDFDownload extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    locale: 'en',
  };

  render() {
    const { locale, level, children } = this.props;
    const Component = this.props.type === 'link' ? Link : Button;

    return (
      <Component
        level={level}
        children={children}
        eventElementName="Pdf-download-link"
        eventProperties={{
          foreign_table: 'groups',
          foreign_id: this.props.group.id,
          locale,
        }}
        href={this.props.group.getPdfUrl(locale)}
        target="_blank"
        onClick={() => {
          // Log exposure to experiment (only available in English)
          if (locale === 'en') {
            CurrentUser.inExpVariant('NEW_PDF');
          }
        }}
      />
    );
  }
}

export default PDFDownload;
